import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';

const state = {
    tarea: {},
    tareas: []
};

const mutations = {
    updateField,
    updateTareas: (state, payload) => {
        state.tareas = payload;
    },
    updateTarea: (state, payload) => {
        state.tarea = payload;
    },
};
const getters = {
    getField,
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
